(function () {
  var auto = document.querySelectorAll('.card-wrapper, .wc-cat, .wc-review, .title-wrapper-with-link, .wc-manifesto__text > *');
  Array.prototype.forEach.call(auto, function (el, i) {
    el.classList.add('wc-reveal');
    el.style.transitionDelay = (i % 4) * 80 + 'ms';
  });
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('wc-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    document.querySelectorAll('.wc-reveal').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('.wc-reveal').forEach(function (el) { el.classList.add('wc-in'); });
  }
  var pl = Array.prototype.slice.call(document.querySelectorAll('[data-wc-parallax]'));
  if (pl.length && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var ticking = false;
    var onScroll = function () {
      if (!ticking) {
        requestAnimationFrame(function () {
          var y = window.scrollY;
          pl.forEach(function (el) {
            var s = parseFloat(el.getAttribute('data-wc-parallax')) || 0.05;
            el.style.setProperty('--wc-py', (y * s * -1) + 'px');
          });
          ticking = false;
        });
        ticking = true;
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }
})();
